// extracted by mini-css-extract-plugin
export default {"submit-button":"style_submit-button__j8DNc","auth-submit-button":"style_auth-submit-button__Epnz2","auth-submit-button-disabled":"style_auth-submit-button-disabled__4Temo"};